module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_3750_Inactive@1x-551f2897d11ef9b19576fd91c92828ae.png";